(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["count-down-clock"] && !Shopify.designMode) return;
  try {
     
  document.getElementsByClassName("collection")[0].classList.add("hide-count");

  let countDownDate = new Date("Nov 28, 2024 18:00:00 GMT+00:00").getTime();

  let x = setInterval(function() {

    let now = new Date().getTime();
      
    let distance = countDownDate - now;
      
    let days = Math.floor(distance / (1000 * 60 * 60 * 24));
    let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // document.getElementById("squish-date-day").innerHTML = days;
    document.getElementById("squish-date-hour").innerHTML = hours;
    document.getElementById("squish-date-minute").innerHTML = minutes;
    document.getElementById("squish-date-second").innerHTML = seconds;
      
    if (distance < 0) {
      clearInterval(x);
      // document.getElementById("squish-date-text").innerHTML = "EXPIRED";

      document.getElementById("squish-date-container").classList.add("hide-count");
      
      document.getElementsByClassName("collection")[0].classList.remove("hide-count");
    }
  }, 1000);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event-count-down-clock"] && !Shopify.designMode) return;
  try {
     
  
  let countDownDate = new Date("Apr 18, 2025 14:00:00 GMT-0400").getTime();

  let x = setInterval(function() {

    let now = new Date().getTime();
      
    let distance = countDownDate - now;
      
    let days = Math.floor(distance / (1000 * 60 * 60 * 24));
    let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distance % (1000 * 60)) / 1000);

    document.getElementById("event-date-day").innerHTML = days;
    document.getElementById("event-date-hour").innerHTML = hours;
    document.getElementById("event-date-minute").innerHTML = minutes;
    document.getElementById("event-date-second").innerHTML = seconds;
      
    if (distance < 0) {
      clearInterval(x);
      document.getElementById("event-date-container").classList.add("hide-count");
    }
  }, 1000);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-countdown"] && !Shopify.designMode) return;
  try {
     

  let countDownDate = new Date("Nov 28, 2024 18:00:00 GMT+00:00").getTime();

  let x = setInterval(function() {

    let now = new Date().getTime();
      
    let distance = countDownDate - now;
      
    let days = Math.floor(distance / (1000 * 60 * 60 * 24));
    let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distance % (1000 * 60)) / 1000);

    document.getElementById("squish-date-hour").innerHTML = hours;
    document.getElementById("squish-date-minute").innerHTML = minutes;
    document.getElementById("squish-date-second").innerHTML = seconds;
      
    if (distance < 0) {
      clearInterval(x);
      // document.getElementById("squish-date-text").innerHTML = "EXPIRED";

    }
  }, 1000);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["squish-date"] && !Shopify.designMode) return;
  try {
    

  let countDownDate = new Date("Aug 16, 2024 09:00:00 GMT+00:00").getTime();

  let x = setInterval(function() {

    let now = new Date().getTime();
      
    let distance = countDownDate - now;
      
    let days = Math.floor(distance / (1000 * 60 * 60 * 24));
    let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distance % (1000 * 60)) / 1000);

    document.getElementById("squish-date-day").innerHTML = days;
    document.getElementById("squish-date-hour").innerHTML = hours;
    document.getElementById("squish-date-minute").innerHTML = minutes;
    document.getElementById("squish-date-second").innerHTML = seconds;
      
    if (distance < 0) {
      clearInterval(x);
      // document.getElementById("squish-date-text").innerHTML = "EXPIRED";
    }
  }, 1000);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teethoftomorrow"] && !Shopify.designMode) return;
  try {
    
    const goToPetition = document.getElementById("tot-item-go-to-petition");
    const petitionItem = document.getElementById("tot-item-petition");

    goToPetition.addEventListener("click", () => {
        petitionItem.scrollIntoView({ alignToTop: true, behavior: "smooth" });
    });

  } catch(e) { console.error(e); }
})();
})();
